<section class="connect-page">
  <div class="connect-card settings-hero">
    <div>
      <span class="connect-pill">Settings</span>
      <h1>Provider catalog</h1>
        <p class="connect-muted">Manage provider definitions and OAuth secrets in Shine Auth. Uses the shared provider
            catalog schema.</p>
        <p class="connect-muted">Shine Auth API: {{ authApiUrl }}</p>
    </div>
    <div class="hero-actions">
      <button mat-button color="primary" (click)="refreshProviders()">Refresh catalog</button>
    </div>
  </div>

  <div class="connect-grid settings-grid">
    <mat-card class="connect-card">
      <mat-card-header>
        <div class="card-title-row">
          <p class="connect-section-title">Providers</p>
            <span class="connect-muted">Pulled from the Shine Auth catalog.</span>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="provider-header">
          <div>
            <p class="connect-muted">Click a provider to edit full details, auth modes, OAuth config, and utilities.</p>
            @if (error) {
              <p class="connect-muted warn">{{ error }}</p>
            }
          </div>
          <div class="provider-actions">
            <button mat-stroked-button color="primary" (click)="refreshProviders()" [disabled]="loadingProviders">
              Refresh
            </button>
            <button mat-flat-button color="primary" (click)="createProvider()">Add provider</button>
          </div>
        </div>
        <mat-divider></mat-divider>
        @if (loadingProviders) {
          <div class="loading-row">
            <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
            <span class="connect-muted">Loading providers...</span>
          </div>
        } @else {
          @if (providers.length === 0) {
              <p class="connect-muted">No providers loaded yet. Check Shine Auth seeding.</p>
          } @else {
            <div class="provider-grid">
              @for (p of providers; track p.id) {
                <button type="button" class="provider-card" (click)="openProvider(p)">
                  <div class="provider-card__top">
                    <div>
                      <p class="provider-name">{{ p.name }}</p>
                      <p class="connect-muted">{{ p.ref }}</p>
                    </div>
                      <span class="connect-chip neutral">{{ p.auth.default || 'apiKey' }} default</span>
                  </div>
                  <div class="provider-card__meta">
                    @if (p.tags?.length) {
                      <span class="connect-muted">{{ (p.tags || []).join(' · ') }}</span>
                    } @else {
                      <span class="connect-muted">No tags</span>
                    }
                    @if (p.docsUrl) {
                      <span class="connect-muted dot">Docs</span>
                    }
                  </div>
                  <div class="provider-card__footer">
                    <span class="connect-muted">Open detail</span>
                    <i-tabler name="arrow-right"></i-tabler>
                  </div>
                </button>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </div>
</section>
